// @react-functional

import { useRef, useEffect } from 'react';

export const useIsMounted = () => {
  const isMounted = useRef(false);
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return { getIsMounted: () => isMounted.current };
};
